module.exports = __webpack_public_path__ + "static/media/life_insurance.6f020fad.svg";